import { render, staticRenderFns } from "./AddCaseDialog.vue?vue&type=template&id=799ff052"
import script from "./AddCaseDialog.vue?vue&type=script&lang=js"
export * from "./AddCaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports